import NotificationApi from "../../api/NotificationApi";
import AuthService from "../../session/AuthService";
import { USER_LOGINED , EXPIRED_DATE , NOTIFICATION_COUNT , OWNER_DATA, EMPLOYEER_ID} from "../types";

export const getExpiredDate = (expiredDateStatus) => async (dispatch) => {
 
  dispatch({
    type: EXPIRED_DATE,
    payload: expiredDateStatus,
  });
};



export const userLogined = (status) => async (dispatch) => {

  dispatch({
    type: USER_LOGINED,
    payload: status,
  });
};

export const employerId = (status) => async (dispatch) => {

  dispatch({
    type: EMPLOYEER_ID,
    payload: status,
  });
};

// export const userPurchaseStatus = (purchaseStatus) = (dispatch) => {
//   dispatch({
//     type: USER_PURCHASE_STATUS,
//     payload: purchaseStatus,
//   });
// }




export const getnotificationCount = () => async (dispatch) => {

  try {
    let obj = {
      page: 0,
      search: "",
      receiverId: parseInt(AuthService.getUserId()),
      filterkey: "",
    };
    NotificationApi.getNotificationforAdmin(obj)
      .then((response) => {
        console.log(response.data.data , "in redux it show");
        if (response.data && response.data) {
          dispatch({
            type: NOTIFICATION_COUNT,
            payload: response.data.data,
          });
        }
      })
      .catch((error) => {
        console.log(error  ,"in redux");
      });
  } catch (error) {
    dispatch({
      type: NOTIFICATION_COUNT,
      payload: [],
    });
  }
  return [];
};


export const AdminClickedUser = (status) => async (dispatch) => {

  dispatch({
    type: OWNER_DATA,
    payload: status,
  });
};


